// extracted by mini-css-extract-plugin
export default {"container":"Section1_container__5cTRR"};